import { categories, leaks } from "@/mocks/leaks";
import type { Leak, LeakCategory } from "@/mocks/leaks";

export const SITE_ORIGIN = "https://menglonghua.cn";

export function getCategory(slug: string): LeakCategory | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategory(slug)?.name ?? "爆料";
}

export function getLeakById(id: string): Leak | undefined {
  return leaks.find((item) => item.id === id);
}

export function getLeaksByCategory(slug: string): Leak[] {
  if (slug === "all") return leaks;
  return leaks.filter((item) => item.category === slug);
}

export function getRelatedLeaks(leak: Leak, limit = 3): Leak[] {
  const sameCategory = leaks.filter(
    (item) => item.id !== leak.id && item.category === leak.category,
  );
  const sharedTag = leaks.filter(
    (item) =>
      item.id !== leak.id &&
      item.category !== leak.category &&
      item.tags.some((tag) => leak.tags.includes(tag)),
  );
  const fill = leaks.filter(
    (item) =>
      item.id !== leak.id &&
      !sameCategory.includes(item) &&
      !sharedTag.includes(item),
  );
  return [...sameCategory, ...sharedTag, ...fill].slice(0, limit);
}

export function getTopLeaks(limit = 5): Leak[] {
  return [...leaks].sort((a, b) => b.hot - a.hot).slice(0, limit);
}

export function formatHot(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)} 万`;
  return `${value}`;
}

export function getCategoryCount(slug: string): number {
  return getLeaksByCategory(slug).length;
}